import gql from "graphql-tag";

export const CustomGetStaffMyselfResponder = gql`
  query GetStaffMyself {
    getStaffMyself {
      id_account
      responder {
        tenant_id
        id
        name
      }
    }
  }
`;
